// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-container-W6mQ1 {
	margin: 5px auto;
	padding: 0 0 40px;
	margin-top: 30px;
	max-width: var(--max-content-width);
}`, "",{"version":3,"sources":["webpack://./src/routes/payment/Payment.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,mCAAmC;AACpC","sourcesContent":[".container {\n\tmargin: 5px auto;\n\tpadding: 0 0 40px;\n\tmargin-top: 30px;\n\tmax-width: var(--max-content-width);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Payment-container-W6mQ1`
};
module.exports = ___CSS_LOADER_EXPORT___;
